<template>
    <div class='container'>
        <div :class="['plan-item-col', isBasic ? 'isBasic' : '', isRecommended || isBasic ? 'active' : '']"
            ref="container">
            <div class="device-group">
                <span
                    v-html="deviceGroupInfo.title"
                />
            </div>
            <!-- pc title -->
            <h4 class="pc">
                <span class="title-label" :style="{'background-color': `${color}`}"></span>
                <span>{{ currentPlan.title }}</span>
                <span v-if="isCurrentSubscriptionPlan" class="current-plan">
                    {{ !isMobile? $t('current_plan'): $t('current_plan_abbr') }}
                </span>
            </h4>
            <!-- END pc title -->
            <div class="content-wrap">
                <div class="price-content" ref="selectors">
                    <reo-select
                        ref="cycleFrequency"
                        class="plan-select"
                        :widthOut='selectorStyle.widthOut'
                        :heightOut='selectorStyle.heightOut'
                        :widthIn='selectorStyle.widthIn'
                        :heightIn='selectorStyle.heightIn'
                        :selectMarginLeft='selectorStyle.selectMarginLeft'
                        :triangleRight='selectorStyle.triangleRight'
                        :fontSizeIn ='selectorStyle.fontSizeIn'
                        :fontSizeOut='selectorStyle.fontSizeOut'
                        :maxHeight ='selectorStyle.maxHeight'
                        :optionListMinWidth="selectorStyle.optionListMinWidth"
                        :options="videoRetentionDayOptions"
                        :defaultSelected="defaultVideoLifeTime"
                        @input="handleVideoLifeTimeChange"
                    >
                    </reo-select>
                    <reo-select
                        ref="deviceQuantity"
                        class="plan-select"
                        :widthOut='selectorStyle.widthOut'
                        :heightOut='selectorStyle.heightOut'
                        :widthIn='selectorStyle.widthIn'
                        :heightIn='selectorStyle.heightIn'
                        :selectMarginLeft='selectorStyle.selectMarginLeft'
                        :triangleRight='selectorStyle.triangleRight'
                        :fontSizeIn ='selectorStyle.fontSizeIn'
                        :fontSizeOut='selectorStyle.fontSizeOut'
                        :maxHeight ='selectorStyle.maxHeight'
                        :optionListMinWidth="selectorStyle.optionListMinWidth"
                        :options="deviceQuantityOptions"
                        :defaultSelected="defaultCurrentPlanProductIndex"
                        :value="currentPlanProductIndex"
                        @input="handleDeviceQuantityChange"
                    >
                    </reo-select>
                    <!-- sale price -->
                    <p class="short-cycle">
                        <template v-if="!free">
                            <span class="currency">{{ currentPlan.currency }}</span>
                            <span class="price">{{ $n( monthlySalePrice, 'fixed2') }}</span>
                            <span class="cycle">/{{ $t('month') }}</span>
                        </template>
                        <template v-else>
                            <span class="currency">{{ isBasic ? $t( 'homepage.basic_free_des' ) : $t( 'plan.free' ) }}</span>
                        </template>
                        <span
                            :class="['long-cycle']"
                            v-if="monthlyRegularPrice > monthlySalePrice">
                            <span class="currency">{{ currentPlan.currency }}</span>
                            <span class="price">{{ $n( monthlyRegularPrice, 'fixed2') }}</span>
                            <span class="cycle">/{{ $t('month') }}</span>
                        </span>
                        <span class="bill" v-if="!isMonthlyPlan">
                            <br />
                            {{ $t('plan.bill',{
                                cycle: $tc(`cycle.${currentDuration.unit}`, currentDuration.amount, {
                                    count: currentDuration.amount
                                })}).toString().toLowerCase() }}
                        </span>
                    </p>

                    <!-- END regular price -->
                </div>
                <div class="plan-notice-box" ref="planNoticeBox">
                    <reo-common-button
                        class='subscription-button'
                        @click="goSubscription"
                        ga-label="Subscribe to Reolink Cloud"
                        :label="subscribeButtonLabel"
                        :disabled="isOtherRegion"
                    />
                    <p class="plan-discount" v-if="planDiscount">{{ planDiscount }}</p>
                    <p class="plan-notice" v-if='currentPlan.i18n.description'>{{ currentPlan.i18n.description }}</p>
                    <rich-text class="plan-notice" v-if='currentPlanPromotionText' :html="currentPlanPromotionText"/>
                    <p class='renewal' v-if="planRenewableInfo?.isRenewable" >
                        <reo-link
                            :text="renewNoticeText"
                            @click="goDashboard"
                            :size="14"
                        />
                    </p>
                </div>
                <ul class="bottom-content">
                    <li>
                        <i class="icon-check"></i>
                        <span class="plan-feature-number" v-html="filterHelper('planHistory', currentPlan)"></span>
                    </li>
                    <li>
                        <i class="icon-check"></i>
                        <span v-html="filterHelper('planCamera', currentPlan)"></span>
                    </li>
                    <li>
                        <i class="icon-check"></i>
                        <span v-html="filterHelper('planCapacity', currentPlan)"></span>
                    </li>
                    <li v-if="filterHelper('planRichNotification', currentPlan)!==''">
                        <i class="icon-check"></i>
                        <span v-html="filterHelper('planRichNotification', currentPlan)"></span>
                        <reo-tip>
                            <span>{{$t('homepage.richNotification')}}</span>
                        </reo-tip>
                    </li>
                    <template v-if="showAiInfo">
                        <template v-for="feature in config.aiFeatures">
                            <li v-if="currentPlan.style[`cloud_ai.${feature}`]" :key="feature">
                                <i class="icon-check"></i>
                                <span>
                                    <span>{{ $t(`cloud_ai.${feature}`) }}</span>
                                </span>
                            </li>
                        </template>
                    </template>
                </ul>
            </div>
            <div class="device-group-info" ref="deviceGroupInfo">
                <div class="content">
                    <h5 class='listTitle'>{{$t('subscribe.showModels')}}</h5>
                    <div class='description'>
                        <p v-if="deviceGroupInfo.des" v-html="deviceGroupInfo.des" class="des"></p>
                        <p class='text-link countryBtn' @click="handleShowAvailableDevices">{{$t('modelShow.check_full_list')}}<span>+</span></p>
                    </div>
                </div>
            </div>
        </div>
        <portal to="body" :disabled="!showAvailableDevices">
            <available-devices-dialog
                v-if="showAvailableDevices"
                @cancel="showAvailableDevices = false"
                :cloud-product-lists="cloudProductLists"
                :supported-device-list="deviceGroupInfo.models"
                :device-group-des='deviceGroupInfo.des'
            />
        </portal>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import ReoTip from '@/components/promptMessage.vue';
import ReoSelect from '@/basic/ReoSelect.vue';
import { config } from 'CONFIG';
import { timeResolvePDT } from '@/common/js/date';
import { ISelectorStyle, IReoSelectOption, IPromotionItem, IPlan } from '@reolink-cloud/interface';
import { getPlanPromotionText } from '@/utils/business';
import { IDeviceGroupWithPlans, IDuration } from '@/view/reolink/homepage/lib/types';
import { ITemporalObj } from '@/interface/api/products/plan';
import { CustomerFilters } from '@/interface';
import AvailableDevicesDialog from '@/components/Dialogs/AvailableDevicesDialog.vue';
import { Portal } from 'portal-vue';
import { getPlansByDuration } from '../lib/utils';
import { IPlanRenewableInfo, ISubscribeArgs, ISubscriptionWithPlanInfo } from '../lib/types';
import ReoLink from '@/basic/Link.vue';
import { mapGetters } from 'vuex';
import reolinkGa from '@/common/js/gtagPageview';

export default Vue.extend({

    components: {

        ReoSelect,
        ReoTip,
        AvailableDevicesDialog,
        Portal,
        ReoLink,

    },
    props: {

        deviceGroupInfo: Object as PropType<IDeviceGroupWithPlans>,
        subscription: Object as PropType<ISubscriptionWithPlanInfo | null>,
        listIndex: Number,
        activeItem: Number,
        promotions: Array as PropType<IPromotionItem[]>,
        showAiInfo: Boolean,
        currentDuration: Object as PropType<IDuration>,
        cloudProductLists: Object,
        checkIfPlanRenewable: Function as PropType<( id: string ) => IPlanRenewableInfo>,
        isUpdatePlan: Boolean,

    },
    data () {

        return {

            currentVideoLifeTime: 0,
            defaultVideoLifeTime: 0,
            currentPlanProductIndex: 0,
            defaultCurrentPlanProductIndex: 0,
            config,
            dialogStack: [] as any[],
            showAvailableDevices: false,
            optionListWidth: 3.64,
            selectorsObserver: null as ResizeObserver | null,

        };

    },
    computed: {
        ...mapGetters( ['isStorageAvailableCountry', 'isLogin'] as const ),
        isOtherRegion(): boolean {

            return !this.isStorageAvailableCountry;

        },

        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },

        plansInCurrentDuration(): IPlan[] {

            return getPlansByDuration( this.deviceGroupInfo.planList, this.currentDuration );

        },

        currentPlan (): IPlan {

            return this.plansInCurrentDuration[this.currentPlanProductIndex];

        },

        isBasic (): boolean {

            return this.currentPlan.title === config.basic_plan_title;

        },

        isRecommended (): boolean {

            return this.currentPlan.style[ 'plan.recommended' ];

        },

        videoRetentionDayOptions (): IReoSelectOption[] {

            let arr = this.plansInCurrentDuration.map(( product ) => {

                return product.style['cloud_storage.video_lifetime'] ?? 0;

            });

            return [...new Set( arr )].map(( maxStorageDay ) => {

                return {

                    value: maxStorageDay,
                    label: maxStorageDay === 0 ? this.$t( 'plan.rich_only' ) : this.$t( 'plan.maxHistory', {
                        history: maxStorageDay
                    }).toString().replace( '<span>', '' ).replace( '</span>', '' ),
                    id: maxStorageDay

                } as IReoSelectOption;

            });

        },

        deviceQuantityOptions (): IReoSelectOption[] {

            let arr: IReoSelectOption[] = [];

            for ( const [index, product] of this.plansInCurrentDuration.entries()) {

                if ( product.style['cloud_storage.video_lifetime'] === this.currentVideoLifeTime ) {

                    const deviceQuantity = product.style['cloud_storage.max_device_quantity'];

                    arr.push({
                        value: index,
                        label: this.$tc( 'maxDeviceQuantity', deviceQuantity!, {

                            count: deviceQuantity

                        }),
                        id: index
                    });

                }

            }
            return arr;

        },

        color (): string {

            return this.currentPlan.style[ 'plan.display_color' ];

        },

        userStatus (): string {

            return this.$store.state.user.status;

        },

        unit (): string {

            let interval = this.currentPlan.duration;
            return this.$tc( `cycle_unit.${interval.unit}`, interval.amount, {

                count: interval.amount

            });

        },

        free (): boolean {

            return Number( this.currentPlan.pricing.salePrice ) === 0;

        },

        limitedDay () {

            let limitedDay = this.currentPlan[ 'style' ][ 'virtual_product.effect_ttl' ];
            if ( !limitedDay ) {

                return {};

            }
            let date = timeResolvePDT( limitedDay );
            return {

                year: date.year,
                monthAbbr: date.monthAbbr,
                monthlong: date.monthLong,
                dateOfMonthOrder: date.dateOfMonthOrder,
                dateOfMonth: date.dateOfMonth

            };

        },

        planDiscount (): string {

            let currentPlan = this.currentPlan;
            let { regularPrice: rawRegularPrice, salePrice: rawSalePrice } = currentPlan.pricing;
            const regularPrice = Number( rawRegularPrice );
            const salePrice = Number( rawSalePrice );
            if ( salePrice === 0 || !regularPrice || regularPrice === 0 || regularPrice <= salePrice ) {

                return '';

            }
            let discount = 100 - ( salePrice * 100 / regularPrice );
            return discount < 1 ? '' : this.$t( 'plan.discount', { discount: discount.toFixed( 0 ) }) as string;

        },

        selectorStyle (): ISelectorStyle {

            return !this.isMobile ? {
                widthOut: -1,
                heightOut: 0.48,
                widthIn: -1,
                heightIn: 0.48,
                selectMarginLeft: 0.16,
                triangleRight: 0.16,
                maxHeight: 3.08,
                fontSizeIn: 0.14,
                fontSizeOut: 0.16,
                optionListMinWidth: this.optionListWidth
            } : {
                widthOut: -1,
                heightOut: 0.48,
                widthIn: -1,
                heightIn: 0.4,
                selectMarginLeft: 0.16,
                triangleRight: 0.16,
                maxHeight: 4.8,
                fontSizeIn: 0.16,
                fontSizeOut: 0.14
            };

        },
        currentPlanPromotionText (): string | undefined {

            return getPlanPromotionText( this.promotions, this.currentPlan );

        },

        /**
         * 将当前套餐的售价转换为按月计算的价格
         */
        monthlySalePrice (): number {

            const salePrice = Number( this.currentPlan.pricing?.salePrice || 0 );
            const duration = this.currentPlan.duration;

            return this.convertToMonthlyPrice( salePrice, duration );

        },

        /**
         * 将当前套餐的原价转换为按月计算的价格
         */
        monthlyRegularPrice (): number {

            const regularPrice = Number( this.currentPlan.pricing?.regularPrice || 0 );
            const duration = this.currentPlan.duration;

            return this.convertToMonthlyPrice( regularPrice, duration );

        },

        isMonthlyPlan(): boolean {

            return this.currentDuration.unit === 'month' && this.currentDuration.amount === 1;

        },

        isCurrentSubscriptionPlan(): boolean {

            return this.subscription?.plan.id === this.currentPlan.id;

        },

        planRenewableInfo(): IPlanRenewableInfo | undefined {

            return this.checkIfPlanRenewable ? this.checkIfPlanRenewable( this.currentPlan.id ) : undefined;

        },

        renewNoticeText(): string {

            if ( this.planRenewableInfo?.autoRenewEnabled ) {

                return  this.$t( 'subscribe.renewEffectWithAutoRenew' ).toString() + '' + this.$t( 'plan.checkPlan' ).toString();

            } else {

                return  this.$t( 'subscribe.renewEffect' ).toString() + ' ' + this.$t( 'plan.renewal' ).toString();

            }

        },
        subscribeButtonLabel(): string {

            if ( this.isOtherRegion ) {

                return this.$t( 'subscribe.not_available' ).toString();

            } else {

                return this.isUpdatePlan ? this.$t( 'cloud.noVerify.choose' ).toString() : this.$t( 'cloud.noVerify.subscribe' ).toString();

            }

        },

    },
    mounted() {

        const selectors = this.$refs.selectors as HTMLElement;
        if ( selectors ) {

            this.selectorsObserver = new ResizeObserver(() => {

                this.optionListWidth = selectors.clientWidth / 100;

            });
            this.selectorsObserver.observe( selectors );

        }

    },
    beforeDestroy() {

        if ( this.selectorsObserver ) {

            this.selectorsObserver.disconnect();

        }

    },
    methods: {

        /**
         * 将价格根据周期转换为按月计算
         */
        convertToMonthlyPrice ( price: number, duration: ITemporalObj ): number {

            if ( price === 0 ) return 0;

            const { amount, unit } = duration;

            switch ( unit ) {

                case 'day':
                    // 天转月：价格 * 30.44 / 天数 (30.44是平均每月天数)
                    return ( price * 30.44 ) / amount;
                case 'week':
                    // 周转月：价格 * 4.345 / 周数 (4.345是平均每月周数)
                    return ( price * 4.345 ) / amount;
                case 'month':
                    // 月：价格 / 月数
                    return price / amount;
                case 'year':
                    // 年转月：价格 / (年数 * 12)
                    return price / ( amount * 12 );
                default:
                    return price;

            }

        },

        toggle (): void {

            let container: any = $( this.$refs.container! );
            container.toggleClass( 'active' );
            container.find( '.content-wrap' ).slideToggle( 500 );
            if ( container.hasClass( 'active' )) {

                this.$emit( 'changeActive', this.listIndex );

            }

        },
        dialogMounted ( ref ): void {

            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActivated' );

            }
            this.dialogStack.push( ref );

        },
        dialogDestroyed ( ): void {

            this.dialogStack.pop();
            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActivated' );

            }

        },
        filterHelper( name: keyof CustomerFilters, data: any ): string {

            return ( this.$options.filters as unknown as CustomerFilters )[name].call( this, data );

        },
        goSubscription(): void {

            reolinkGa.sendSimpleEvent( 'Cloud Storage Service-Subscribe' );
            this.$emit( 'goSubscription', {
                plan: this.currentPlan,
                series: this.cloudProductLists.planSeries[this.currentPlan.seriesKey],
                availableModels: this.deviceGroupInfo.models.map( item => item.text )
            } as ISubscribeArgs );

        },
        setDefaultSelected(): void {

            const recommendPlans = this.plansInCurrentDuration.filter( plan => plan.style['plan.recommended'] ).sort(
                ( a, b ) => Number( a.style['plan.sort'] ) - Number( b.style['plan.sort'] )
            );
            const defaultPlan = recommendPlans[0] ?? this.plansInCurrentDuration[0];
            this.currentVideoLifeTime = defaultPlan.style['cloud_storage.video_lifetime'] ?? 1;
            this.currentPlanProductIndex = this.plansInCurrentDuration.findIndex( plan => plan.id === defaultPlan.id );
            this.defaultVideoLifeTime = defaultPlan.style['cloud_storage.video_lifetime'] ?? 1;
            this.defaultCurrentPlanProductIndex = this.plansInCurrentDuration.findIndex( plan => plan.id === defaultPlan.id );

        },
        handleVideoLifeTimeChange( val: number ): void {

            reolinkGa.sendSimpleEvent( `Cloud Storage Service-video history` );
            if ( val === this.currentVideoLifeTime ) return;
            this.currentVideoLifeTime = val;
            const currentPlans = this.plansInCurrentDuration.filter( plan => plan.style['cloud_storage.video_lifetime'] === val );
            const recommendPlans = currentPlans.filter( plan => plan.style['plan.recommended'] ).sort(
                ( a, b ) => Number( a.style['plan.sort'] ) - Number( b.style['plan.sort'] )
            );
            const selectedPlan = recommendPlans[0] ?? currentPlans[0];
            const selectedProductIndex = this.plansInCurrentDuration.findIndex( plan => plan.id === selectedPlan.id );
            this.defaultCurrentPlanProductIndex = selectedProductIndex;
            this.currentPlanProductIndex = selectedProductIndex;

        },
        handleDeviceQuantityChange( val: number ): void {

            reolinkGa.sendSimpleEvent( `Cloud Storage Service-cameras` );
            this.currentPlanProductIndex = val;

        },
        handleShowAvailableDevices(): void {

            reolinkGa.sendSimpleEvent( `Cloud Storage Service-Full List` );
            this.showAvailableDevices = true;

        },
        async goDashboard(): Promise<void> {

            await this.$router.push({ path: '/user/dashboard/' });

        },
        getDeviceGroupInfoEl(): HTMLElement | undefined {

            return this.$refs.deviceGroupInfo as HTMLElement | undefined;

        },

        getPlanNoticeBoxEl(): HTMLElement | undefined {

            return this.$refs.planNoticeBox as HTMLElement | undefined;

        }

    },
    watch: {

        activeItem ( activeItem ) {

            if ( activeItem !== this.listIndex ) {

                let container: any = $( this.$refs.container! );
                container.removeClass( 'active' );
                container.find( '.content-wrap' ).slideUp( 500 );

            }

        },

        videoRetentionDayOptions: {

            handler ( ) {

                this.setDefaultSelected();

            },
            immediate: true

        },

        currentPlan() {

            this.$emit( 'updateCurrentPlan' );

        }

    }

});
</script>

<style lang="less">
.plan-item-col .bottom-content li>span>span{
    font-weight: 600;
}
.plan-feature-number span{
    font-weight: 600;
}
</style>

<style scoped lang="less">
.container{
    height: 100%;
    position: relative;
    max-width: 484px;
    text-align: left;
    .mobile({
        max-width: 100%;;
    })
}
.plan-item-col{
    border-radius: @border-radius-level-2;
    background-color: @bg_02;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 32px 40px;
    padding-top: 0;
    position: relative;
    transition: padding 0.5s;
    overflow: hidden;
    border: 1px solid @b_2;
    padding-top: 146px;
    @media @pc {
        .content-wrap{
            display: flex;
            flex-direction: column;
        }
    }
    .mobile({
        padding: 20px;
        padding-top: 131px;
    });

}
.plan-item-col.active h4.mobile .title-text i{
    transform: rotate(0deg);
}
h4 {
    font-weight: 600;
    &.pc{
        font-size: 24px;
        margin-bottom: 24px;
        position: absolute;
        top: 60px;
        left: 32px;
        .mobile({
            font-size: 22px;
        });
        .free-title{
            font-size: 0.16rem;
            font-weight: 400;
            position: absolute;
            left: 50%;
            bottom: -0.25rem;
            width: 100%;
            transform: translateX(-50%);
        }
    }
    span {
        vertical-align: middle;
    }
}
.price-content{
    position: relative;
    top: 0;
    left: 0;
}
.plan-notice-box{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    min-height: var(--plan-notice-box-height, auto);
}
.plan-discount{
    font-size: 14px;
    line-height: 1.2;
    position: absolute;
    top: -10px;
    right: -10px;
    color: @white;
    padding: 6px 12px;
    border-radius: 20px 20px 20px 2px;
    background-color: #FF894A;
}
.plan-notice{
    margin-top: 16px;
    width: 100%;
    font-size: 14px;
    color: #E74330;
    height: 20px;
}
.plan-select{
    position: relative;
    & + .plan-select {
        margin-top: 0.16rem;
    }
}
.short-cycle{
    margin: 24px 0;
    .currency{
        font-size: 28px;
        font-weight: 600;
        .mobile({
            font-size: 24px;
        })
    }
    .price{
        font-weight: 600;
        font-size: 28px;
        .mobile({
            font-size: 24px;
        })
    }
    .cycle{
        font-size: 16px;
        color: @font_secondary;
    }
}
.long-cycle{
    text-decoration: line-through;
    color: @font_secondary;
    margin-left: 12px;
    .text{
        font-size: 14px;
    }
    .currency{
        font-weight: 400;
        .text();
    }
    .price{
        font-weight: 500;
        .text();
    }
    .cycle{
        .text();
    }
}
.bottom-content{
    padding-top: 24px;
    border-top: 1px solid @line;
    margin-top: 24px;
    text-align: left;
    i{
        font-size: 20px;
        vertical-align: middle;
        margin-right: 8px;
    }
    span{
        vertical-align: middle;
        font-size: 14px;
    }
    li+li{
        margin-top: 12px;
    }
    .tooltip{
        display: inline-block;
        vertical-align: middle;
    }
}
.top-label{
    display: block;
    height: 3px;
    position: absolute;
    top: 0;
    width: calc(100% - 20px);
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    border-radius: 1rem;
}
.recommend-label{
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.8rem 0.8rem 0 0;
    position: absolute;
    left: 0;
    top: 0;
    i{
        color: #fff;
        font-size: 0.25rem;
        position: absolute;
        top: -0.67rem;
        left: 0.1rem;
    }
}
.title-label{
    display: inline-block;
    border-radius: 100%;
    width: 10px;
    height: 10px;
    margin-right: 0.1rem;
}

.price-free{
    font-size: 0.36rem;
    font-weight: 500;
    padding-top: 0.7rem;
}

.device-group{
    background-color: @bg_01;
    border-radius: @border-radius-level-2 0px;
    padding: 8px 24px;
    font-size: 14px;
    max-width: 80%;
    margin-bottom: 36px;
    position: absolute;
    left: 0;
    top: 0;
    width: fit-content;
    .mobile({
        margin-bottom: 16px;
        left: -20px;
    });
    span{
        font-weight: 500;
    }
}

.device-group-info{
    background-color: @bg_01;
    padding: 16px;
    border-radius: @border-radius-level-button;
    min-height: var(--device-group-info-height, 132px);
    box-sizing: border-box;

    .content{
        font-size: 14px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        justify-content: space-between;
        height: 100%;
        .listTitle{
            font-size: 14px;
        }
        .description{
            p{
                font-weight: 500;
            }
            .des{
                margin-bottom: 8px;
            }
            .countryBtn{
                cursor: pointer;
            }
        }
    }
}

.bill{
    padding-left: 4px;
    color: @font_secondary;
}

.current-plan{

    display: inline-block;
    padding: 0 16px;
    margin-left: 4px;
    background-color: #FFAC3E;
    color: #fff;
    border-radius: 0.08rem;
    font-weight: 500;
    .mobile({

    });
}

.renewal{
    margin-top: 16px;
}

.content-wrap{
    flex: 1;
    margin-bottom: 24px;
}

</style>
